import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import Modal from 'react-modal'
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { BrowserRouter } from 'react-router-dom'
import "leaflet/dist/leaflet.css"

const container = document.getElementById('root')

Modal.setAppElement(container)

document.addEventListener(
	'pointerdown',
	(event) => {
		const button = event.target.closest(
			'button.btn.btn-info, button.door-action-estimate'
		)

		if (button && document.activeElement instanceof HTMLElement) {
			document.activeElement.blur()
		}
	},
	true
)

const root = createRoot(container)

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
)